// src/utils/auth.js
import { jwtDecode } from "jwt-decode";
import { decryptToken } from "./Encryption";

export const isAuthenticated = () => {
  const encryptedToken = localStorage.getItem("token");
  if (!encryptedToken) return false;
  const token = decryptToken(encryptedToken);
  // console.log("🔓 Decrypted Token:", token); 
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      localStorage.removeItem("token");
      return false;
    }
    return true;
  } catch (error) {
    localStorage.removeItem("token");
    return false;
  }
};


